import React, { useState, useEffect, isValidElement } from "react";
import {
  useLocation,
  useHistory,
  BrowserRouter,
  useParams,
} from "react-router-dom";
import "./App.css";
import Routes from "./Routes/Index";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./Routes/scrollToTop";
import isAuthenticate from "./utils/auth";
import GlobalContext from "./context/GlobalContext";
import "react-loading-skeleton/dist/skeleton.css";
import {
  getUserProfileData,
  logout,
  getAllReview,
  getUserInviteSent,
  getUserInviteReceived,
} from "./API/userData";
import axios from "axios";
import socket from "./utils/socket";
import axiosInstance from "./utils/axiosconfig";
import { chunk } from "lodash";
import { ToastContainer } from "react-toastify";
import { getStores } from "./API/stores";
import { ModalProvider } from "./context/ModalContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { SearchProvider } from "./context/SearchContext";
import { Provider } from "react-redux";
import store from "./store";
import ChatWidget from "./API/ChatWidget";

global.defaultPasswordRule =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;

let allSite = [
  { site: "app.doorsey.com", storeID: 1 },
  { site: "revolauctions.com", storeID: 2 },
  { site: "excelhomeauctions.com", storeID: 3 },
];

function App() {
  const [online, isOnline] = useState(navigator.onLine);
  const [socketDisconnect, setSocketDisconnect] = useState(false);
  const [bidInc, setBidInc] = useState({});
  const [declineOff, setDeclineOff] = useState({});
  const [isAuth, setAuth] = useState(isAuthenticate() !== undefined);
  const [isLoading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [location, setLocation] = useState({});
  const [time, setTime] = useState("");
  const [bids, setBids] = useState({});
  const [comments, setComments] = useState({});
  const [getRecentProperty, setResentProperty] = useState([]);
  const [award, setAward] = useState({});
  const [allReview, setAllReview] = useState([]);
  const [storeID, setStoreID] = useState(null);
  const [subPath, setSubPath] = useState("");
  const [liveSite, setLiveSite] = useState(false);
  const [headerSelectedLocation, setHeaderSelectedLocation] = useState({
    id: "",
    cities: "",
    state: "",
    lat: "",
    lng: "",
  });
  const [propertyTime, setPropertyTime] = useState({});
  const [completedVerifications, setCompletedVerifications] = useState({
    userConnection: false,
    financeInformation: false,
    billingInformation: false,
  });
  const [agentVerificationStatus, setAgentVerificationStatus] = useState({
    accountVerification: false,
    clientConnetion: false,
  });
  const [userConnection, setUserConnection] = useState(false);
  const [agentAccountVerification, setAgentAccountVerification] =
    useState(false);
  const [financeInfo, setFinanceInfo] = useState(false);
  const [billingInfo, setBillingInfo] = useState(false);
  const [invitesSent, setInvitesSent] = useState([]);
  const [invitesReceived, setInvitesReceived] = useState([]);
  const [financeInformation, setFinanceInformation] = useState({});
  const [billingInformation, setBillingInformaction] = useState([]);
  const [agentDetails, setAgentDetails] = useState({});
  const [socketLocation, setSocketLocation] = useState({});
  const [soketDisconnect, setSokcetDisconnect] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const history = useHistory();
  const store1 = {
    userLoggedIn: { get: isAuth, set: setAuth },
    loading: { get: isLoading, set: setLoading },
    userDetails: { get: user, set: setUser },
    userLocation: { get: location, set: setLocation },
    currentTime: { get: time, set: setTime },
    bid: { get: bids, set: setBids },
    comment: { get: comments, set: setComments },
    resentProperty: { get: getRecentProperty, set: setResentProperty },
    propertyAwarded: { get: award, set: setAward },
    review: { get: allReview, set: setAllReview },
    headerLocation: {
      get: headerSelectedLocation,
      set: setHeaderSelectedLocation,
    },
    verificationStatus: {
      get: completedVerifications,
      set: setCompletedVerifications,
    },
    sentInvites: { get: invitesSent, set: setInvitesSent },
    receivedInvites: { get: invitesReceived, set: setInvitesReceived },
    financeDetails: { get: financeInformation, set: setFinanceInformation },
    billingDetails: { get: billingInformation, set: setBillingInformaction },
    agentVerification: {
      get: agentVerificationStatus,
      set: setAgentVerificationStatus,
    },
    agentVerificationDetails: { get: agentDetails, set: setAgentDetails },
    mapRadius: { get: socketLocation, set: setSocketLocation },
    bidIncrement: { get: bidInc, set: setBidInc },
    declinedOffer: { get: declineOff, set: setDeclineOff },
    storeDetails: storeData,
  };
  const changeTheme = (stores) => {
    return document.documentElement.style.setProperty(
      "--primColor",
      stores?.store.primary_color,
    );
  };
  // Estimate browser zoom reliably for current window (no hardcoded monitor size)
  const getBrowserZoomPercentage = () => {
    const viewportScale = window.visualViewport?.scale;
    if (viewportScale && viewportScale > 0) {
      return Math.max(50, Math.min(200, Math.round(viewportScale * 100)));
    }

    const outer = Number(window.outerWidth) || 0;
    const inner = Number(window.innerWidth) || 0;
    if (outer > 0 && inner > 0) {
      const estimatedZoom = (outer / inner) * 100;
      return Math.max(50, Math.min(200, Math.round(estimatedZoom)));
    }

    return 100;
  };

  const getClosestPresetKey = (presets, actualZoomPercent) => {
    let closest = Number(Object.keys(presets)[0]);
    Object.keys(presets).forEach((key) => {
      const current = Number(key);
      if (
        Math.abs(current - actualZoomPercent) <
        Math.abs(closest - actualZoomPercent)
      ) {
        closest = current;
      }
    });
    return closest;
  };

  // Automatically calculate optimal viewport based on browser zoom and screen size
  const calculateOptimalViewport = (hasAlaska = false) => {
    const zoomPercent = getBrowserZoomPercentage();
    const viewportWidth = window.innerWidth;
    const isLargeScreen = viewportWidth >= 1900;

    const largeScreenContinentalViewports = {
      90: {
        lat: 33.44117790144515,
        long: -90.7752685546875,
        north: 51.28296077819041,
        south: 11.038924096956254,
        east: -51.33435058593751,
        west: -130.2161865234375,
        zoomLevel: 5,
      },
      100: {
        lat: 33.44117790144515,
        long: -90.7752685546875,
        north: 51.28296077819041,
        south: 11.038924096956254,
        east: -51.33435058593751,
        west: -130.2161865234375,
        zoomLevel: 5,
      },
      110: {
        lat: 31.13604380876885,
        long: -96.07826668024062,
        north: 58.012952751620716,
        south: -6.00034513443398,
        east: -28.79799324274062,
        west: -163.3585401177406,
        zoomLevel: 4,
      },
      125: {
        lat: 31.906119766411262,
        long: -91.2366943359375,
        north: 57.88601952689679,
        south: -3.9622213846105967,
        east: -34.72302246093751,
        west: -147.7503662109375,
        zoomLevel: 4,
      },
    };

    const largeScreenAlaskaViewports = {
      90: {
        lat: 50.506873088221354,
        long: -111.7152099609375,
        north: 72.59089642050309,
        south: 9.828825692672494,
        east: -32.83337402343751,
        west: -190.5970458984375,
        zoomLevel: 4,
      },
      100: {
        lat: 50.506873088221354,
        long: -111.7152099609375,
        north: 72.59089642050309,
        south: 9.828825692672494,
        east: -32.83337402343751,
        west: -190.5970458984375,
        zoomLevel: 4,
      },
      110: {
        lat: 56.41755606937004,
        long: -113.15461742877959,
        north: 81.09423672392727,
        south: -8.921960158471386,
        east: 21.40592944622041,
        west: -247.7151643037796,
        zoomLevel: 3,
      },
      125: {
        lat: 49.83700502181694,
        long: -109.3421630859375,
        north: 78.78460396935888,
        south: -17.394025472029554,
        east: 3.6851806640625107,
        west: -222.3695068359375,
        zoomLevel: 3,
      },
    };

    if (isLargeScreen) {
      const presets = hasAlaska
        ? largeScreenAlaskaViewports
        : largeScreenContinentalViewports;

      let selectedPresetKey = 100;
      if (viewportWidth <= 2200) {
        selectedPresetKey = 125;
      } else if (viewportWidth <= 2500) {
        selectedPresetKey = 110;
      } else if (viewportWidth >= 2700) {
        selectedPresetKey = 90;
      } else {
        selectedPresetKey = getClosestPresetKey(presets, zoomPercent);
      }

      if (!presets[selectedPresetKey]) {
        selectedPresetKey = getClosestPresetKey(presets, zoomPercent);
      }

      const selectedViewport = presets[selectedPresetKey];
      return selectedViewport;
    }

    const continentalViewports = {
      60: {
        lat: 35.84183381818312,
        long: -96.35412572520842,
        north: 61.82865445708563,
        south: -2.342766421175644,
        east: -33.02893041270842,
        west: -159.6793210377084,
        zoomLevel: 4,
      },
      75: {
        lat: 34.7,
        long: -95.3,
        north: 58,
        south: 1,
        east: -38,
        west: -152,
        zoomLevel: 4,
      },
      90: {
        lat: 33.44117790144515,
        long: -90.7752685546875,
        north: 51.28296077819041,
        south: 11.038924096956254,
        east: -51.33435058593751,
        west: -130.2161865234375,
        zoomLevel: 5,
      },
      100: {
        lat: 33.44117790144515,
        long: -90.7752685546875,
        north: 51.28296077819041,
        south: 11.038924096956254,
        east: -51.33435058593751,
        west: -130.2161865234375,
        zoomLevel: 5,
      },
      110: {
        lat: 35.4087890439729,
        long: -92.64893639087676,
        north: 61.908982236264926,
        south: -3.5769742093751895,
        east: -37.014170765876756,
        west: -148.28370201587674,
        zoomLevel: 3,
      },
      125: {
        lat: 31.906119766411262,
        long: -91.2366943359375,
        north: 57.88601952689679,
        south: -3.9622213846105967,
        east: -34.72302246093751,
        west: -147.7503662109375,
        zoomLevel: 4,
      },
      150: {
        lat: 31.26348194042833,
        long: -92.12292435765266,
        north: 53.241519428172964,
        south: 2.7498681741965183,
        east: -50.50671342015267,
        west: -133.73913529515266,
        zoomLevel: 4,
      },
    };

    const alaskaViewports = {
      60: {
        lat: 47.54135210109797,
        long: -102.283447265625,
        north: 75.20615726056732,
        south: -8.589106360422303,
        east: 4.547607421875011,
        west: -209.114501953125,
        zoomLevel: 4,
      },
      75: {
        lat: 48,
        long: -103,
        north: 76,
        south: -10,
        east: 3,
        west: -210,
        zoomLevel: 4,
      },
      90: {
        lat: 50.506873088221354,
        long: -111.7152099609375,
        north: 72.59089642050309,
        south: 9.828825692672494,
        east: -32.83337402343751,
        west: -190.5970458984375,
        zoomLevel: 4,
      },
      100: {
        lat: 50.506873088221354,
        long: -111.7152099609375,
        north: 72.59089642050309,
        south: 9.828825692672494,
        east: -32.83337402343751,
        west: -190.5970458984375,
        zoomLevel: 4,
      },
      110: {
        lat: 51.687570084349126,
        long: -116.41935396194457,
        north: 80.66523622966477,
        south: -21.839022785892595,
        east: -5.149822711944569,
        west: -227.68888521194458,
        zoomLevel: 2,
      },
      125: {
        lat: 47,
        long: -101.2,
        north: 73.8,
        south: -7,
        east: 7,
        west: -207,
        zoomLevel: 3,
      },
      150: {
        lat: 49.44714145796104,
        long: -104.57409533858299,
        north: 75.32298105303323,
        south: -3.3263088038730366,
        east: -21.341673463583,
        west: -187.806517213583,
        zoomLevel: 3,
      },
    };

    const presets = hasAlaska ? alaskaViewports : continentalViewports;

    let selectedPresetKey = null;
    if (viewportWidth <= 1500) {
      selectedPresetKey = 110;
    } else if (viewportWidth <= 1800) {
      selectedPresetKey = 150;
    } else if (viewportWidth <= 1900) {
      selectedPresetKey = 125;
    }

    if (!selectedPresetKey || !presets[selectedPresetKey]) {
      selectedPresetKey = getClosestPresetKey(presets, zoomPercent);
    }

    const selectedViewport = presets[selectedPresetKey];
    return selectedViewport;
  };

  const getDefaultViewportByWidth = (hasAlaska = false) => {
    return {
      ...calculateOptimalViewport(hasAlaska),
      presetKey: "auto",
    };
  };

  const buildLocationQuery = (viewport) =>
    `status=open&radius=20&load=false&zoom=false&title=United+States&cities=&state=&initial=false&lat=${viewport.lat}&long=${viewport.long}&north=${viewport.north}&south=${viewport.south}&east=${viewport.east}&west=${viewport.west}&zoom_level=${viewport.zoomLevel}`;

  const defaultViewport = getDefaultViewportByWidth(false);
  const defaultViewportWithAlaska = getDefaultViewportByWidth(true);

  const defaultLat = defaultViewport.lat;
  const defaultLong = defaultViewport.long;
  const defaultNorth = defaultViewport.north;
  const defaultSouth = defaultViewport.south;
  const defaultEast = defaultViewport.east;
  const defaultWest = defaultViewport.west;
  const defaultZoomLevel = defaultViewport.zoomLevel;

  global.getDefaultViewportByWidth = getDefaultViewportByWidth;

  global.defaultLocation = buildLocationQuery(defaultViewport);
  global.defaultLocationWithAlaska = buildLocationQuery(
    defaultViewportWithAlaska,
  );

  global.defaultLat = defaultLat;
  global.defaultLong = defaultLong;
  global.defaultNorth = defaultNorth;
  global.defaultSouth = defaultSouth;
  global.defaultEast = defaultEast;
  global.defaultWest = defaultWest;
  global.defaultZoomLevel = defaultZoomLevel;

  useEffect(() => {
    if (subPath) {
      setStoreID(parseInt(subPath, 10));
    }
  }, [subPath]);

  useEffect(() => {
    let windowURL = window.location.href.split("/");
    let url = windowURL[2];
    if (
      url === "doorseych.ecommerce.auction" ||
      url === "localhost:3000" ||
      url === "192.168.150.222:3000" ||
      url === "192.168.20.109:3000" ||
      url === "192.168.150.232:3000" ||
      url === process.env.REACT_APP_URL
    ) {
      const store_id = window.location.pathname.split("/")[1];
      setStoreID(parseInt(store_id, 10));
      setLiveSite(false);
    } else {
      let obj = allSite.find((o) => o.site === url);
      if (obj) {
        setStoreID(parseInt(obj.storeID, 10));
        setLiveSite(true);
      }
    }
  }, []);

  useEffect(async () => {
    if (storeID > 0) {
      let stores = await getStores(storeID);
      localStorage.removeItem("site_id");
      localStorage.removeItem("store_id");
      if (stores.status === true) {
        changeTheme(stores);
        setStoreData(stores);
        localStorage.setItem("site_id", stores?.store.site_id);
        localStorage.setItem("store_id", stores?.store.id);
      }
    }
  }, [storeID]);

  const site_id = localStorage.getItem("site_id");

  useEffect(() => {
    socket.on("connect", () => {
      setSocketDisconnect(false);
    });
    // socket.on("sliservertime", (data) => setTime(data.dTime));
    socket.on("bidAddtime", (data) => {
      setBids(data);
    });
    socket.on("comments", (data) => setComments(data));
    socket.on("awardedProperty", (data) => {
      setAward(data);
    });
    socket.on("location", (data) => {
      setSocketLocation(data);
    });
    socket.on("bidIncrement", (data) => {
      setBidInc(data);
    });
    socket.on("declinedOffer", (data) => {
      setDeclineOff(data);
    });
    socket.on("disconnect", () => {
      setSocketDisconnect(true);
    });

    // getLocation();
    // if (site_id != (null || undefined)) {
    //   getReview(site_id);
    // }

    window.deviceType = getDeviceType();
  }, []);

  window.addEventListener("focus", () => {
    if (!socket.connected) {
      socket.connect();
    }
  });

  useEffect(() => {
    window.addEventListener("online", () => {
      setSocketDisconnect(false);
    });

    window.addEventListener("offline", () => {
      setSocketDisconnect(true);
    });
  }, [socketDisconnect]);

  // Register the event listeners
  // window.addEventListener("offline", setOffline);
  // window.addEventListener("online", setOnline);

  // // cleanup if we unmount
  // return () => {
  //   window.removeEventListener("offline", setOffline);
  //   window.removeEventListener("online", setOnline);
  // };

  useEffect(() => {
    if (process.env.REACT_APP_AUTO_REFRESH === "ON") {
      let visibilityHidden, visibilityChange;
      // Opera 12.10 and Firefox 18 and later support
      if (typeof document.hidden !== "undefined") {
        visibilityHidden = "hidden";
        visibilityChange = "visibilitychange";
      } else if (typeof document.mozHidden !== "undefined") {
        visibilityHidden = "mozHidden";
        visibilityChange = "mozvisibilitychange";
      } else if (typeof document.msHidden !== "undefined") {
        visibilityHidden = "msHidden";
        visibilityChange = "msvisibilitychange";
      } else if (typeof document.webkitHidden !== "undefined") {
        visibilityHidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
      }
      document.addEventListener("visibilitychange", function () {
        if (
          !document[visibilityHidden] &&
          window.location.href.includes("/property")
        ) {
          window.location.reload(true);
        }
      });
    }
  }, [
    document.hidden,
    document.mozHidden,
    document.msHidden,
    document.webkitHidden,
  ]);

  useEffect(() => {
    if (isAuthenticate()) {
      getUserProfile();
    }
  }, [isAuthenticate(), site_id]);
  const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua,
      )
    ) {
      return "mobile";
    }
    return "desktop";
  };
  const setOnline = () => {
    isOnline(true);
    window.location.reload(true);
  };
  const setOffline = () => {
    window.isOnline(false);
  };

  const getReview = async (siteid) => {
    try {
      let data = await getAllReview(siteid);
      if (Array.isArray(data)) {
        setAllReview(chunk(data, 3));
      }
    } catch (err) {
      console.error(err, "=>err");
    }
  };

  const getLocation = async () => {
    let { data } = await axios.get(process.env.REACT_APP_GEO_LOCATION);
    if (data.status === "success") {
      setLocation({
        city: data.city,
        lat: data.lat,
        lon: data.lon,
        currentLat: data.lat,
        currentLon: data.lon,
        state: data.regionName,
        countryCode: data.countryCode,
        ipAddress: data.query,
      });
    }
    // let searchData = await getSearch({
    //   cities: [data.city],
    //   page: 1,
    //   limit: 3,
    //   status: "",
    // });
    // searchData.status === true &&
    //   setResentProperty(searchData.result.productdetails);
  };

  const getUserProfile = async () => {
    if (site_id != (null || undefined)) {
      let data = await getUserProfileData(site_id);
      // let inviteSent = await getUserInviteSent(site_id);
      // let inviteRecieved = await getUserInviteReceived(site_id);
      if (data) {
        setUser({
          email: data.userDetails.email,
          first_name: data.userDetails.first_name,
          role: data.userDetails.role,
          profiletype: data.userDetails.profiletype,
          last_name: data.userDetails.last_name,
          user_name: data.userDetails.username,
          status: data.userDetails.status,
          id: data.userDetails.id,
          phone: data.userDetails.phone,
          address: data.userDetails.address1,
          zip: data.userDetails.zip,
          city: data.userDetails.city,
          state: data.userDetails.state,
          companyName: data.userDetails.companyName,
          serviceType: data.userDetails.serviceType,
          created: data.userDetails.created_at,
          aboutme: data.userDetails.aboutme,
          avatar: data.userDetails.avatar,
          limit: data.userDetails.reserve_amount,
          customerid: data.userDetails.customerid,
          agent_exempt_request: data.userDetails.agent_exempt_request,
          finance_exempt_request: data.userDetails.finance_exempt_request,
          card_name: data.userDetails.card_name,
          myAgent: data.my_agent,
          card_date: data.userDetails.card_updated,
          //agent_approved: data.userDetails.agent_approved,
          bid_approval: data.userDetails.bid_approval,
          commentCount: data.userDetails.commentCount,
          bidsCount: data.userDetails.bidsCount,
          purchaseCount: data.userDetails.purchaseCount,
          notification: data.userDetails.notification,
        });

        // setInvitesSent(inviteSent);
        // setInvitesReceived(inviteRecieved);
        if (data.userDetails.fin_doc && data.userDetails.reserve_amount) {
          setFinanceInformation({
            financeDocuments: [
              data.userDetails.fin_doc,
              data.userDetails.fin_doc2,
              data.userDetails.fin_doc3,
              data.userDetails.fin_doc4,
              data.userDetails.fin_doc5,
            ],
            purchasePower: data.userDetails.reserve_amount,
            lenderEmail: data.userDetails.lender_email,
            financeType: data.userDetails.fin_type,
          });
        }
        if (data.cardDetails.length > 0) {
          setBillingInformaction(data.cardDetails);
        }
        if (
          data.userDetails.profiletype === "agent" &&
          data.userDetails.companyName
        ) {
          setAgentDetails({
            brokerageOffice: data.userDetails.companyName,
            brokerageOfficeUrl: data.userDetails.brokerage_url,
            phone: data.userDetails.phone,
          });
        }
      } else {
        localStorage.removeItem("userToken");
        // setAuth(false);
        // setUser({});
        clearGlobalVariables();
        logout();
      }
    }
  };

  const clearGlobalVariables = () => {
    setAuth(false);
    setUser({});
    setInvitesSent([]);
    setInvitesReceived([]);
    setFinanceInformation({});
    setBillingInformaction([]);
    setAgentDetails({});
  };

  useEffect(() => {
    setAgentVerificationStatus({
      accountVerification: agentAccountVerification,
      clientConnetion: userConnection,
    });
  }, [userConnection, agentAccountVerification]);

  useEffect(() => {
    setCompletedVerifications({
      userConnection: userConnection,
      financeInformation: financeInfo,
      billingInformation: billingInfo,
    });
  }, [userConnection, financeInfo, billingInfo]);
  // useEffect(() => {
  //   if (
  //     locationPath &&
  //     locationPath.pathname &&
  //     locationPath.pathname === "/upcoming"
  //   ) {
  //     getLocation();
  //   }
  // }, [locationPath]);
  useEffect(() => {
    if (invitesSent.length > 0 || invitesReceived.length > 0) {
      setUserConnection(true);
    } else if (
      invitesSent.length === 0 &&
      invitesReceived.length === 0 &&
      !user.agent_exempt_request
    ) {
      setUserConnection(false);
    }
  }, [invitesSent, invitesReceived]);

  useEffect(() => {
    if (Object.keys(financeInformation).length > 0) {
      setFinanceInfo(true);
    } else if (!user.finance_exempt_request) {
      setFinanceInfo(false);
    }
  }, [financeInformation]);

  useEffect(() => {
    if (billingInformation.length > 0) {
      setBillingInfo(true);
    } else {
      setBillingInfo(false);
    }
  }, [billingInformation]);

  useEffect(() => {
    if (user) {
      if (user.finance_exempt_request) {
        setFinanceInfo(true);
      }
      if (user.agent_exempt_request) {
        setUserConnection(true);
      }
      if (user.bid_approval) {
        setAgentAccountVerification(true);
      }
    }
  }, [user]);

  // Logo
  global.logo_path = process.env.REACT_APP_LOGO_PATH || "/images/mylogo.png";

  // Facicon
  global.favicon_path = process.env.REACT_APP_FAVICON_PATH || "/favicon.png";

  // Image Alt
  global.image_alt = process.env.REACT_APP_IMAGE_ALT || "nextdoorauctions.com";

  // Site Name
  global.site_name = process.env.REACT_APP_SITE_NAME || "Next Door Auctions";

  // Site Url
  global.site_url = process.env.REACT_APP_SITE_URL || "Next Door Auctions";

  // Support Email
  global.support_email =
    process.env.REACT_APP_SUPPORT_EMAIL || "support@auctionsoftware.com";

  return (
    <React.StrictMode>
      <div className="App">
        {socketDisconnect && (
          <p className="network-issue">
            Network has been disconnected trying to reconnect... or click here
            to{" "}
            <span
              onClick={() => window.location.reload(0)}
              className="network-reload"
            >
              reload
            </span>
          </p>
        )}
        <ToastContainer pauseOnFocusLoss={false} />
        <Provider store={store}>
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          >
            <GlobalContext.Provider value={store1}>
              <ModalProvider>
                <SearchProvider>
                  <Router>
                    <ScrollToTop />
                    <Routes />
                  </Router>
                </SearchProvider>
              </ModalProvider>
            </GlobalContext.Provider>
          </GoogleOAuthProvider>
        </Provider>
        {/* <ChatWidget /> */}
      </div>
    </React.StrictMode>
  );
}

export default App;
